const Content = [
  {
    year: "2020",
    day: "firstday",
    ar1: [1, 1, 0, 7, 8, 10, 7, 7, 0, 2, 4, 0, 11, 1, 3, 2, 2],
    ar2: [0, 0, 0, 0, 5, 18, 3, 2, 1, 0, 0, 4, 0, 0, 0, 0, 0],
    ar3: [5, 5, 1, 4, 8, 18, 9, 2, 0, 5, 11, 0, 5, 2, 8, 3, 2],
  },
  {
    year: "2020",
    day: "secondday",
    ar1: [1, 1, 0, 7, 8, 10, 8, 7, 0, 2, 4, 0, 11, 8, 3, 2, 2],
    ar2: [0, 4, 0, 0, 5, 18, 6, 2, 1, 0, 0, 4, 0, 0, 0, 0, 0],
    ar3: [5, 5, 1, 4, 8, 18, 9, 2, 0, 5, 11, 0, 5, 2, 8, 3, 2],
  },
  {
    year: "2019",
    day: "firstday",
    ar1: [0, 0, 0, 0, 5, 18, 3, 2, 1, 0, 0, 4, 0, 0, 0, 0, 0],
    ar2: [1, 1, 0, 7, 8, 10, 7, 7, 0, 2, 4, 0, 11, 1, 3, 2, 2],
    ar3: [5, 5, 1, 4, 8, 18, 9, 2, 0, 5, 11, 0, 5, 2, 8, 3, 2],
  },
];
export default Content;
